import React from 'react'
import PropTypes from 'prop-types'
import FirstYearInterest from './FirstYearInterest'
import BlendedAPY from './BlendedAPY'
import '../css/Deposit.css'
import NumberFormat from 'react-number-format'

const Deposit = ({ onChange, blendedAPY, firstYrInterest }) => (
  <React.Fragment>
    <div>
      <div>
        <form onSubmit={e => e.preventDefault()}>
          <div>
            <div>
              <label className="deposit-label" htmlFor="deposit">
                Enter Deposit Amount
              </label>
              <br />
              <br />


              <NumberFormat className="deposit-input"
                id="deposit"
                label="deposit"
                name="deposit" 
                thousandSeparator={true} 
                prefix={'$'} 
                placeholder="$0" 
                onValueChange={(values) => {
                  const { formattedValue, value } = values; 
                  onChange(value);
                }} />

            </div>
          </div>
        </form>
      </div>
    </div>
    <BlendedAPY val={blendedAPY} />
    <FirstYearInterest val={firstYrInterest} />
  </React.Fragment>
)

Deposit.propTypes = {
  onChange: PropTypes.func.isRequired,
}

export default Deposit



// WEBPACK FOOTER //
// ./src/components/Deposit.js